import {
  CollapsibleContent as Content,
  Root,
  CollapsibleTrigger as Trigger,
} from '@radix-ui/react-collapsible';
import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';

import { cn } from '@/shared/utils/cn/cn.util';

export const Collapsible = Root;

export type CollapsibleTriggerProps = ComponentPropsWithoutRef<typeof Trigger>;
export type CollapsibleContentProps = ComponentPropsWithoutRef<typeof Content>;

export const CollapsibleTrigger = forwardRef<ElementRef<typeof Trigger>, CollapsibleTriggerProps>(
  function CollapsibleTrigger({ className, ...props }, ref) {
    return (
      <Trigger
        ref={ref}
        className={cn(
          'flex w-full items-center gap-sm rounded-md text-label text-foreground transition-colors duration-fast ease-standard',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
          className,
        )}
        {...props}
      />
    );
  },
);

export const CollapsibleContent = forwardRef<ElementRef<typeof Content>, CollapsibleContentProps>(
  function CollapsibleContent({ className, ...props }, ref) {
    return <Content ref={ref} className={cn('overflow-hidden', className)} {...props} />;
  },
);
